import { 
  Input,   
  OnInit,
  Renderer, 
  Directive, 
  ElementRef, 
  HostListener,
  AfterViewInit     
} from '@angular/core';

@Directive({ selector: '[fontadjust]' })
export class FontAdjustDirective implements AfterViewInit, OnInit {
  
  @Input('container') container: any;
  @Input('fontadjust') fittext: any;
  
  constructor(public el: ElementRef, public renderer: Renderer) { }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setFontSize();
  }

  ngOnInit() {
    this.setFontSize();
  }

  setFontSize() {
    this.el.nativeElement.style.setProperty('font-size', (this.container.clientWidth / 5) + "px");
  }

  ngAfterViewInit() { }

}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/directives/fontadjust.directive.ts